import { userInfoSync } from 'hub-http/userInfo';

export const useUserInfo = () => {
  try {
    // Reads userInfo from the cache.
    // Because this is a library component, userInfo should be already loaded within the consuming app.
    return userInfoSync();
  } catch {
    return undefined;
  }
};
